import { Tooltip, Typography, TypographyProps } from '@healthinal/ui';
import React, { HTMLProps, isValidElement, ReactElement, useRef, useState } from 'react';
import { TypographyLink } from '../TypographyLink.tsx';

const TOOLTIP_DELAY = 300;
export function TooltipCell({ children, ...tdProps }: HTMLProps<HTMLTableCellElement>) {
  const tdRef = useRef<HTMLTableCellElement>(null);
  const typographyRefs = useRef<Array<HTMLElement | null>>([]); // References to all child <Typography> elements
  const [open, setOpen] = useState(false);

  const handleOpenTooltip = () => {
    const isTdTruncated = tdRef.current && tdRef.current.scrollWidth > tdRef.current.clientWidth;

    const isTypographyTruncated = typographyRefs.current.some((ref) => ref && ref.scrollWidth > ref.clientWidth);

    setOpen(isTdTruncated || isTypographyTruncated);
  };
  return (
    <td {...tdProps} ref={tdRef}>
      <Tooltip
        variant={'outlined'}
        title={children}
        enterDelay={TOOLTIP_DELAY}
        enterNextDelay={TOOLTIP_DELAY}
        open={open}
        onClose={() => setOpen(false)}
        onOpen={handleOpenTooltip}>
        <span>
          {React.Children.map(children, (child, index) => {
            if (isValidElement(child) && (child.type === Typography || child.type === TypographyLink)) {
              return React.cloneElement(child as ReactElement<TypographyProps>, {
                ref: (el: HTMLSpanElement | null) => {
                  typographyRefs.current[index] = el;
                },
                style: { overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' },
              });
            }
            return child;
          })}
        </span>
      </Tooltip>
    </td>
  );
}
